import React from 'react';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {translations} from 'presentation/translations-new';
import {BookingFlowLayout} from '../../components/BookingFlowLayout';

import {HEALTH_LABELS, HEALTH_LABELS_WITHOUT_DISTRICT} from './constants';
import {useBackButtonBooking} from 'presentation/modules/booking/shared/hooks/useBackButtonBooking';
import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {bookHealth} = translations['pt-br'].privateFlow.services;

export function HealthBooking() {
	const bookingData = useBookingStore(state => state.bookingData);
	const isUsingGeolocation = !bookingData.isManualLocation;
	useBackButtonBooking({flowType: BookingTypeEnum.HEALTH});

	return (
		<BookingFlowLayout
			flowType={FlowEnum.HEALTH}
			headerTitle={bookHealth}
			stepLabels={isUsingGeolocation ? HEALTH_LABELS_WITHOUT_DISTRICT : HEALTH_LABELS}
		/>
	);
}
